import PropTypes from "prop-types";
import React from "react";
import { Typography, Button, Box } from "@mui/material";
import { Print } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import Table from "../../../../components/Table/Table";
import Modal from "../../../../components/Modal/index";
import moment from "moment-timezone";
import { capitalize } from "../../../../utils/string";
import {
  formatWithTimeZone,
  getTimeDifference
} from "../../../../utils/datetime";
import { makeGetEntities } from "../../../../redux/selectors/selectors";
import { useSelector } from "react-redux";
import { visionURL } from "../../../../config/environment";

const selector = makeGetEntities();

const getPrintAttendeesUrl = trainingObjectId =>
  `${visionURL}/reports/9733/run_report?filter[training_object_id]=${trainingObjectId}&invoke=print`;

const getAttendeesColumns = sessionTimeZone => [
  {
    title: "Name",
    field: "name",
    options: {
      sorting: true
    }
  },
  {
    title: "emailAddress",
    field: "userEmail",
    options: {
      sorting: true
    }
  },
  {
    title: "joinTime",
    field: "joinTime",
    options: {
      sorting: true
    },
    type: "datetime",
    render: ({ joinTime }) =>
      formatWithTimeZone(joinTime, sessionTimeZone, "hh:mm A z")
  },
  {
    title: "leftTime",
    field: "leaveTime",
    options: {
      sorting: true
    },
    type: "datetime",
    render: ({ leaveTime }) =>
      formatWithTimeZone(leaveTime, sessionTimeZone, "hh:mm A z")
  },
  {
    title: "duration",
    options: {
      sorting: true
    },
    customSort: (a, b) =>
      getTimeDifference(a.leaveTime, a.joinTime) -
      getTimeDifference(b.leaveTime, b.joinTime),

    render: ({ joinTime, leaveTime }) =>
      capitalize(
        moment.duration(getTimeDifference(leaveTime, joinTime)).humanize()
      )
  }
];

const CourseSessionAttendeesModal = ({ onClose, open, sessionId }) => {
  const { t } = useTranslation();

  const { sessionData } = useSelector(({ contentCoursesState }) => ({
    sessionData: selector(contentCoursesState, {
      type: "trainingObject",
      id: sessionId
    })
  }));

  const handlePrintAttendees = () => {
    window.open(getPrintAttendeesUrl(sessionId), "_blank");
  };

  return (
    <Modal
      disableEnforceFocus
      showCloseIcon
      maxWidth="lg"
      fullWidth
      fillHeight
      dialogTitle={
        <Typography variant="h4" color="textPrimary">
          {`${t("courseSession.attendeesModalTitle")}: ${sessionData.name}`}
        </Typography>
      }
      dialogContent={
        <Box display="flex" flexDirection="column" my={1} height="100%">
          <Box
            mb={3}
            display="flex"
            justifyContent="flex-end"
            alignItems="flex-start"
          >
            <Button
              color="primary"
              startIcon={<Print />}
              onClick={() => handlePrintAttendees()}
            >
              {t("courseSession.printAttendeesListBtn")}
            </Button>
          </Box>
          <Table
            columns={getAttendeesColumns(sessionData.timeZone)}
            data={sessionData.virtualClassroomAttendees}
            hidePagination={true}
          />
        </Box>
      }
      open={open}
      onClose={onClose}
    />
  );
};

CourseSessionAttendeesModal.propTypes = {
  /**
   * Called to close the Modal
   */
  onClose: PropTypes.func,
  /**
   * True if the modal is open, false otherwise
   */
  open: PropTypes.bool,
  sessionId: PropTypes.string
};

export default CourseSessionAttendeesModal;
